var map = {
	"./jsks/1.png": 1041,
	"./jsks/2.png": 6378,
	"./jsks/3.png": 7955,
	"./jsks/4.png": 7788,
	"./jsks/5.png": 4325,
	"./jsks/6.png": 8574,
	"./sd/1.png": 8147,
	"./sd/2.png": 2536,
	"./weight/10.png": 2416,
	"./weight/100.png": 3762,
	"./weight/20.png": 4629,
	"./weight/200.png": 9153,
	"./weight/5.png": 5502,
	"./weight/50.png": 5359,
	"./weight/500.png": 1110,
	"./weight/customize.png": 706,
	"./yuxx/1.png": 9920,
	"./yuxx/2.png": 4955,
	"./yuxx/3.png": 5954,
	"./yuxx/4.png": 7517,
	"./yuxx/5.png": 5012,
	"./yuxx/6.png": 8575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2200;